import type { ClienteConsolidado } from '../types';
import { formatCurrency, formatKwh, formatPercent } from '../utils.ts';

// Texto dos insights da aba "Insights IA" como dado puro, sem JSX. A tela
// desenha os cards a partir daqui e a exportação escreve as mesmas frases na
// planilha — antes o texto só existia dentro do componente e o Excel não tinha
// como levar a leitura da carteira junto.

export type IdInsight = 'tendencia' | 'concentracao' | 'saldos' | 'lote';

export interface InsightCarteira {
  id: IdInsight;
  titulo: string;
  nivel: string;
  cor: string;
  texto: string;
  recomendacao: string;
}

export function calcularInsightsCarteira(
  clientes: ClienteConsolidado[],
  totalAberto: number,
): InsightCarteira[] {
  const top10 = clientes.slice(0, 10).reduce((s, c) => s + c.valorTotal, 0);
  const top10Pct = totalAberto > 0 ? top10 / totalAberto : 0;
  const saldoTotal = clientes.reduce((s, c) => s + c.saldoAcumulado, 0);

  return [
    {
      id: 'tendencia',
      titulo: 'Inadimplência em Trajetória de Atenção',
      nivel: totalAberto > 500000 ? 'CRÍTICO' : 'ALTO',
      cor: '#ef4444',
      texto: `A carteira inadimplente atingiu ${formatCurrency(totalAberto)} com ${clientes.length} clientes. Sem intervenção estruturada, a tendência é de agravamento progressivo no próximo trimestre.`,
      recomendacao: 'Acionar plano de contingência para os maiores devedores (Top 10). Meta: redução de 30% em 30 dias.',
    },
    {
      id: 'concentracao',
      titulo: 'Concentração Crítica — Regra de Pareto',
      nivel: top10Pct > 0.4 ? 'CRÍTICO' : 'ATENÇÃO',
      cor: '#f97316',
      texto: `${formatPercent(top10Pct * 100)} do valor total está concentrado em apenas 10 clientes. Esta concentração cria dependência perigosa e amplifica o risco sistêmico da carteira.`,
      recomendacao: `Priorizar recuperação agressiva (Extrajudicial) do Top 10 que representa ${formatCurrency(top10)}.`,
    },
    {
      id: 'saldos',
      titulo: 'Risco de Travamento Operacional (Saldos)',
      nivel: saldoTotal > 100000 ? 'ESTRATÉGICO' : 'MÉDIO',
      cor: '#3b82f6',
      texto: `O saldo acumulado total de ${formatKwh(saldoTotal)} representa créditos de energia bloqueados sob titularidades em atraso. Há necessidade de rescisão para liberação dos créditos.`,
      recomendacao: 'Iniciar processo jurídico de rescisão e recuperação de titularidade para clientes estratégicos (Q1 da Matriz de Risco).',
    },
    {
      id: 'lote',
      titulo: 'Oportunidade de Recuperação em Lote',
      nivel: 'OPORTUNIDADE',
      cor: '#10b981',
      texto: 'Clientes na faixa R$1K-5K oferecem o melhor custo-benefício para negociação estruturada. Podem ser atendidos via WhatsApp automatizado pelo VigorHub.',
      recomendacao: 'Lançar campanha de regularização (Até 6x sem juros) para esta faixa específica nas próximas 48 horas.',
    },
  ];
}
